<template>
  <v-select
    :value="value"
    @input="handleInput"
    v-bind="$attrs"
    @focus="loadItems()"
    :items="lead_types"
    :loading="loading"
    item-text="description"
    item-value="id"
  ></v-select>
</template>

<script>
import { index } from "@/services/lead_types";

export default {
  props: {
    value: [Object, Number],
    returnObject: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      lead_types: [],
      loading: false,
    };
  },

  methods: {
    handleInput(event) {
      this.$emit("input", event);
    },

    async loadItems() {
      if (this.lead_types.length > 0) {
        return;
      }

      this.loading = true;
      const response = await index();

      this.lead_types = response;
      this.loading = false;
    },
  },

  created() {
    if (this.value) {
      this.loadItems();
    }
  },
};
</script>
